export default "__VITE_ASSET__D2tj8hXq__"